import React, { useEffect } from "react";

function SelectButtons({input, watch, onSubmit, register}: any) {
  useEffect(() => {
    const { unsubscribe } = watch((value: any) => {
      console.log(value);
      onSubmit(value);
    })
    return () => unsubscribe()
  }, [watch])

  return (
    <div className="select-buttons">
      {input.values.map((item: any, key: number) => {
        return (
          <label className="select-button flex" key={key}>
            <input
              type="radio"
              className="w-0 h-0"
              value={item.value}
              {...register(input?.name || '', { required: input?.required })}
            />
            <div className="radiobutton" />
            <div className="label">{item.label}</div>
          </label>
        )
      })}
    </div>
  )
}

export default SelectButtons;
